import styled from 'styled-components';
import { Button } from '@mui/material';
import { cssVarColors } from '../../Constants/cssVarColors';

export const CallToActionButtonWrapper = styled('div')`
	color: #fff;
	margin-left: -3px;
`;

export const CallToActionButton = styled(Button)`
	background-color: ${cssVarColors.onSurface} !important;
	&:hover {
		background-color: ${cssVarColors.onSurfaceSecondary} !important;
	}
`;

export const BookingButton = styled(Button)`
	background-color: ${cssVarColors.highlight} !important;
	&:hover {
		background-color: ${cssVarColors.highlightAlternative} !important;
	}
`;

export const CallToActionButtonDisabled = styled(Button)`
	background-color: ${cssVarColors.disabled} !important;
	&:hover {
		background-color: ${cssVarColors.disabled} !important;
	}
`;

export const CallToActionButtonSmall = styled(CallToActionButton)`
	padding-top: 0.5em !important;
	padding-bottom: 0.25em !important;
	padding-left: 1em !important;
	padding-right: 1em !important;
`;

export const CallToActionButtonDisabledSmall = styled(CallToActionButtonDisabled)`
	padding-top: 0.25em !important;
	padding-bottom: 0.25em !important;
	padding-left: 1em !important;
	padding-right: 1em !important;
`;

export const BookingButtonSmall = styled(BookingButton)`
	padding-top: 0.25em !important;
	padding-bottom: 0.25em !important;
	padding-left: 1em !important;
	padding-right: 1em !important;
`;

export const CallToActionButtonMedium = styled(CallToActionButton)`
	padding-top: 1.25em !important;
	padding-bottom: 1.25em !important;
	padding-left: 3em !important;
	padding-right: 3em !important;
`;

export const CallToActionButtonDisabledMedium = styled(CallToActionButtonDisabled)`
	padding-top: 1.25em !important;
	padding-bottom: 1.25em !important;
	padding-left: 3em !important;
	padding-right: 3em !important;
`;

export const BookingButtonMedium = styled(BookingButton)`
	padding-top: 1.25em !important;
	padding-bottom: 1.25em !important;
	padding-left: 3em !important;
	padding-right: 3em !important;
`;

export const CallToActionButtonLarge = styled(CallToActionButton)`
	padding-top: 1.25em !important;
	padding-bottom: 1.25em !important;
	padding-left: 3em !important;
	padding-right: 3em !important;
`;

export const CallToActionButtonDisabledLarge = styled(CallToActionButtonDisabled)`
	padding-top: 1.25em !important;
	padding-bottom: 1.25em !important;
	padding-left: 3em !important;
	padding-right: 3em !important;
`;

export const BookingButtonLarge = styled(BookingButton)`
	padding-top: 1.25em !important;
	padding-bottom: 1.25em !important;
	padding-left: 3em !important;
	padding-right: 3em !important;
`;

export const IconWrapper = styled('div')`
	padding-right: 0.5rem;
`;

export const TextWrapper = styled('div')``;
